const className = ['', 'message parker', 'message stark', 'time']
export const ListMsg = ({ message }) => {
  if (!message || message.length === 0) return <></>
  return <>
    {/* <div className="time">
    Today at 11:41
  </div> */}
    {message.filter(e => e.message).map((m, i) => {
      return <div className={className[m.chat_type]} key={i}>
        {m.message}
      </div>
    })}

    {/* <div className="message stark">
      Kid, where'd you come from?
    </div>
    <div className="message parker">
      Field trip! 🤣
    </div>
    <div className="message parker">
      Uh, what is this guy's problem, Mr. Stark? 🤔
    </div>
    <div className="message stark">
      Uh, he's from space, he came here to steal a necklace from a wizard.
    </div> */}
  </>;
};
